import { Fragment } from 'react';
import { type TextProps, YStack } from 'tamagui';

import { Private } from '../security/Private';
import { BodyMediumEmphasized, BodySmallRegular } from '../text/Typography';
import { type BaseRowProps, Row } from './Row';

export interface TextRowProps extends BaseRowProps {
    secondaryText: string;
    secondaryTextProps?: TextProps;
    secondarySubtext?: string;
    secondarySubtextProps?: TextProps;
    isPrivate?: boolean;
}

/**
 * Row component for displaying text information.
 * Use this for read-only information display rows.
 * Use isPrivate prop for sensitive data.
 */
export const TextRow = ({
    secondaryText,
    secondaryTextProps,
    secondarySubtext,
    secondarySubtextProps,
    isPrivate = false,
    ...rowProps
}: TextRowProps) => {
    const SecondaryTextWrapperComponent = isPrivate ? Private : Fragment;

    return (
        <Row
            {...rowProps}
            rightContent={
                <SecondaryTextWrapperComponent>
                    <YStack>
                        <BodyMediumEmphasized
                            maxWidth={200}
                            textAlign="right"
                            {...secondaryTextProps}
                        >
                            {secondaryText}
                        </BodyMediumEmphasized>
                        {secondarySubtext != null && (
                            <BodySmallRegular
                                color="$gray700"
                                textAlign="right"
                                {...secondarySubtextProps}
                            >
                                {secondarySubtext}
                            </BodySmallRegular>
                        )}
                    </YStack>
                </SecondaryTextWrapperComponent>
            }
        />
    );
};
